import { object, string } from 'yup'

const zipErrorMessage = 'Must enter valid zip code'

const requiredString = () => string().required('This field is required')

export default object().shape({
  name: requiredString(),
  address1: requiredString(),
  address2: string().nullable(true),
  city: requiredString(),
  state: requiredString(),
  zip: requiredString().matches(/^\d{5}$/, zipErrorMessage),
})

export const paritalSchema = object().shape({
  name: requiredString(),
})
